var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChat = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "chat_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#chat_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.333 18.333c.473 0 .868-.16 1.188-.479.32-.32.479-.715.479-1.187 0-.473-.16-.868-.48-1.188-.319-.32-.714-.479-1.187-.479-.472 0-.868.16-1.187.48-.32.319-.48.714-.48 1.187 0 .472.16.868.48 1.187.32.32.715.48 1.187.48Zm6.667 0c.472 0 .868-.16 1.188-.479.319-.32.479-.715.479-1.187 0-.473-.16-.868-.48-1.188C20.869 15.16 20.473 15 20 15c-.472 0-.868.16-1.188.48-.319.319-.479.714-.479 1.187 0 .472.16.868.48 1.187.319.32.715.48 1.187.48Zm6.667 0c.472 0 .868-.16 1.187-.479.32-.32.48-.715.48-1.187 0-.473-.16-.868-.48-1.188-.32-.32-.715-.479-1.187-.479-.473 0-.868.16-1.188.48-.32.319-.479.714-.479 1.187 0 .472.16.868.48 1.187.319.32.714.48 1.187.48ZM3.333 36.667v-30c0-.917.327-1.702.98-2.355a3.21 3.21 0 0 1 2.354-.979h26.666a3.21 3.21 0 0 1 2.355.98 3.21 3.21 0 0 1 .979 2.354v20a3.21 3.21 0 0 1-.98 2.354 3.21 3.21 0 0 1-2.354.979H10l-6.667 6.667Zm5.25-10h24.75v-20H6.667v21.875l1.916-1.875Z"
}))));
export default SvgChat;